import axios, { AxiosHeaders } from 'axios';
import HttpStatus from '../../enums/httpStatus.js';
import BaseAuthStrategy from './BaseAuthStrategy.js';

const isUserLoggedIn = (statusCode, responseUrl) => {
  return !(statusCode === HttpStatus?.BadRequest && responseUrl?.includes('/check_cookie'));
};
class NPTokenAuthStrategy extends BaseAuthStrategy {
  constructor(options) {
    super();
    if (!options) {
      throw new Error('NPTokenAuthStrategy options are required');
    }
    this.options = options;
    this.checkOptions();
  }
  redirectToLogin() {
    const currentURL = window.location.href;
    window.location.href = `${this.options.loginPath}login?referer=${encodeURIComponent(currentURL)}`;
  }
  async fetchAccessToken() {
    const response = await axios.request({
      method: 'POST',
      url: `${this.options.authPath}/auth/login-with-cookies`,
      withCredentials: true
    });
    return response.headers['access-token'] || '';
  }
  async refreshAccessToken() {
    const response = await axios.request({
      method: 'POST',
      url: `${this.options.authPath}/auth/refresh`,
      withCredentials: true
    });
    return response.headers['access-token'] || '';
  }
  checkOptions() {
    if (!this.options.authPath) {
      throw new Error('authPath is required');
    }
    if (!this.options.loginPath) {
      throw new Error('loginPath is required');
    }
  }
  async requestInterceptor(config) {
    // Pre-fetch the token if it's not already in the storage.
    try {
      if (!NPTokenAuthStrategy.accessToken) {
        NPTokenAuthStrategy.accessToken = await this.fetchAccessToken();
      }
    } catch (e) {
      this.redirectToLogin();
      throw e;
    }
    const headers = new AxiosHeaders(config.headers);
    headers.Authorization = `Bearer ${NPTokenAuthStrategy.accessToken}`;
    return {
      ...config,
      withCredentials: true,
      headers
    };
  }
  async onResponseError(axios, error) {
    const statusCode = error.response?.status;
    const responseUrl = error.response?.config.url;
    const preventRetry = error.config?.preventRetry;
    if (!preventRetry && statusCode === HttpStatus.Unauthorized) {
      // Refresh the token.
      NPTokenAuthStrategy.accessToken = await this.refreshAccessToken();

      // Retry the request.
      return axios.request({
        ...error.config,
        preventRetry: true
      });
    }
    if (!isUserLoggedIn(statusCode, responseUrl)) {
      this.redirectToLogin();
    }
    throw error;
  }
}

/**
 * @deprecated
 */

export { NPTokenAuthStrategy as default };
//# sourceMappingURL=NPTokenAuthStrategy.js.map
